export default __webpack_public_path__ + "static/media/vb-eye-large.c0e4bd5d.png";